import type { Hip3Market } from "@/types/hip3";
import { marketNotionalOi } from "@/lib/market-utils";

export type GroupedMarkets = {
  asset: string;
  quotes: string[];
  markets: Hip3Market[];
  totalVolume: number;
  totalOpenInterest: number;
};

export function groupMarketsByAsset(markets: Hip3Market[], sort: (rows: Hip3Market[]) => Hip3Market[]): GroupedMarkets[] {
  if (!markets.length) {
    return [];
  }

  const grouped = new Map<string, GroupedMarkets>();

  for (const market of markets) {
    const key = market.baseAsset;
    if (!grouped.has(key)) {
      grouped.set(key, {
        asset: market.baseAsset,
        quotes: [],
        markets: [],
        totalVolume: 0,
        totalOpenInterest: 0,
      });
    }

    const group = grouped.get(key);
    if (!group) continue;

    if (!group.quotes.includes(market.quoteAsset)) {
      group.quotes.push(market.quoteAsset);
    }

    group.markets.push(market);
    group.totalVolume += market.volume24h ?? 0;
    group.totalOpenInterest += marketNotionalOi(market);
  }

  const rows = Array.from(grouped.values()).map((group) => ({
    ...group,
    quotes: [...group.quotes].sort(),
    markets: sort([...group.markets]),
  }));

  return rows.sort((a, b) => b.totalVolume - a.totalVolume);
}
